import { MicroflowApi } from './MicroflowApi'
import { ActivityCreator } from './activities/ActivityCreator'
import { MicroflowContextProvider } from './contextProvider'
import { processingApi } from '@/api/processingApi'

export default {
  install(Vue, options) {
    let { dependencies } = options
    dependencies.vue = Vue
    let microFlowApiInstance = new MicroflowApi(dependencies)

    let activityCreatorInstance = new ActivityCreator(dependencies)
    let microflowContextProvider = new MicroflowContextProvider()
    Vue.$microFlowRunner =  Vue.prototype.$microFlowRunner = { 
      async callMicroFlow (id, startParams, properties, settings) {
        function showLoading() {
          switch (settings?.loadIndicator) {
            case 'blockingUI':
              processingApi.showModal(settings.loadIndicatorText)
              break
            case 'nonBlockingUI':
              processingApi.show()
              break
            case 'noIndicator':
              break
          }
        } 
        let mfResult = undefined
        // clear context if it first call (without start params)
        if (startParams.PageId == undefined && startParams.EventName == undefined) {
          microflowContextProvider.clearContext(id)
        } else {
        // get currentContext and merge it to properties
          let currentContext = microflowContextProvider.getContext(id)
          for (const key in currentContext) {
          // fill only keys absent in parameters object
            if (properties[key] == undefined) {
              properties[key] = currentContext[key]
            }
          }
        }
        // get and call microflow from api
        try {
          showLoading()
          let response = await microFlowApiInstance.callMicroFlow(id, startParams, properties)
          mfResult = response.data
        } catch (e) {
          mfResult = e.response.data
        } finally {
          processingApi.hideAll()
        }

        // save context to storage
        
        let context = mfResult.Context
        if (context) {
          microflowContextProvider.saveContext(id, context)
        }

        // get client activities from microflow result 
        let activities = activityCreatorInstance.getActivities(mfResult)
        // call all of the client activities
        activities.forEach(act => act.run()) 
        return mfResult
      }
    }
 
  }
}